export default {
  header: '我的页面',
  changePassword: {
    header: '更改密码',
    oldPassword: '原有密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    changePassword: '更改密码',
  },

  profile: {
    language: '系统语言',
    header: '我的档案',
    personalInformation: '个人资料',
    chineseName: '中文名称',
    englishName: 'English Name',
    agentCode: '顾问编号',
    contactInformation: '联络资料',
    licenseInformation: {
      header: '牌照资料',
      oci: {
        header: '保监相关',
        ociLicensePrinciples: '保险原理及实务',
        ociLicenseGeneral: '一般保险',
        ociLicenseLongTerm: '长期保险',
        ociLicenseLinkedLongTerm: '投资相连长期保险',
        ociLicenseTravel: '旅游保险代理人',
      },
      sfc: {
        header: '证监相关',
        sfcLicenseType1: '一类',
        sfcLicenseType2: '二类',
        sfcLicenseType3: '三类',
        sfcLicenseType4: '四类',
        sfcLicenseType5: '五类',
        sfcLicenseType6: '六类',
        sfcLicenseType7: '七类',
        sfcLicenseType8: '八类',
        sfcLicenseType9: '九类',
        sfcLicenseType10: '十类'
      }
    }

  }
}


// WEBPACK FOOTER //
// ./src/My/langs/zh_cn/index.js